// extracted by mini-css-extract-plugin
module.exports = {"cont-clinic":"cont-clinic","contClinic":"cont-clinic","container":"container","clinic__flex-wrapp":"clinic__flex-wrapp","clinicFlexWrapp":"clinic__flex-wrapp"};